import { valueof } from '.';

export const CallToActionKind = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  GHOST: 'ghost',
  REVERSE_PRIMARY: 'reverse-primary'
} as const;

export type CallToActionKindType = valueof<typeof CallToActionKind>;

export type ButtonType = 'reset' | 'button' | 'submit';

export type ApplePayButtonStatus = 'loading' | 'loaded' | 'unavailable';
